var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoTrash = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1C54DBA4-E53E-48E0-9D5A-F1FBF0FB9419") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.962,3.9999 L7.962,1.9999 L15.962,1.9999 L15.962,3.9999 L22,3.9999 L22,5.9999 L20.3333407,5.9999 L19,21.9999 L5,21.9999 L3.66665926,5.9999 L2,5.9999 L2,3.9999 L7.962,3.9999 Z M6,5.9999 L7,19.9999 L17,19.9999 L18,5.9999 L6,5.9999 Z M9,17 L9,9 L11,9 L11,17 L9,17 Z M13,17 L13,9 L15,9 L15,17 L13,17 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Style-Guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "white",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "style-guide",
    transform: "translate(-312.000000, -10777.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(60.000000, 10295.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(243.000000, 480.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24x24/ico_trash",
    transform: "translate(7.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fillRule: "nonzero",
    xlinkHref: "#path-1",
    fill: "#191919"
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoTrash);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_trash.e183e13e827afb8b37638c891a52a827.svg";